/* src/components/project-details/project-details.component.scss */
:host {
  display: block;
}
.image-disabled {
  pointer-events: none;
}
.string--limit {
  color: var(--vwui-color-primary);
}
.string--limit_reached {
  color: var(--vwui-color-danger);
}
.input-limit-reached {
  --border-color: var(--vwui-color-danger);
  --border-color-hover: var(--vwui-color-danger);
  --border-color-focus: var(--vwui-color-danger);
}
.processing-thumbnail-spinner {
  position: absolute;
  top: 2px;
  left: 2px;
  border-radius: var(--vwui-card--radius, var(--vwui--radius--md)) 0;
  z-index: 2;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  background: #fff;
  line-height: 24px;
  font-size: small;
  padding: 0.5rem 0.8rem 0.5rem 0.5rem;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
  transition-delay: 0.3s;
}
.processing-thumbnail-spinner--show {
  opacity: 1;
}
.processing-thumbnail-spinner svg {
  animation: 1s linear 0s infinite normal none running loading-spinner;
  animation-duration: 750ms;
  color: inherit;
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: top;
  margin: 0 0.25rem 0 0;
}
.processing-thumbnail-spinner svg circle {
  fill: transparent;
  stroke-width: 5px;
  stroke-dasharray: 128px;
  stroke-dashoffset: 82px;
  stroke: currentcolor;
}
@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
/*# sourceMappingURL=project-details.component-NAD7UTX7.css.map */
